@if (!toggleBannerMessage) {
  <div
     class="fdx-c-notification
     fdx-c-notification--info
     fdx-c-notification--full-width
     fdx-c-notification--responsive-inline">
    <div class="fdx-c-notification__main fdx-u-py--1">
      <div class="fdx-c-notification__header">
        <ciam-icon class="fdx-c-icon" aria-hidden="true" key="circle-exclamation"></ciam-icon>
      </div>
      <div class="fdx-c-notification__body">
        <div class="fdx-c-notification__description">
          <span aria-atomic="true" aria-live="assertive">
            {{description}}
          </span>
          <span tabindex='0' id='bannerLink' class='fdx-c-link fdx-u-cursor--pointer'
            (click)="navigate2faSection()"
            (keydown.enter)="navigate2faSection()"
            aria-atomic="true"
            aria-live="assertive">
            {{link}}
          </span>
        </div>
      </div>
      <div class="fdx-c-notification__footer">
        <button class="fdx-c-button fdx-c-button--icon"
          (click)="closeBanner()"
          aria-label="close notification message">
          <ciam-icon class="fdx-c-icon" aria-hidden="true" key="cross"></ciam-icon>
        </button>
      </div>
    </div>
  </div>
}
